<div class="dropdown relative w-full min-w-0">
  <div hlMenu class="!block w-full min-w-0">
    <button
      type="button"
      hlMenuButton
      class="main-logo group flex w-full min-w-0 items-center gap-1 rounded-lg px-0 py-0 text-left transition hover:opacity-90 disabled:cursor-default"
      [ngClass]="triggerClass"
      [disabled]="!canSwitchWorkspace || !!switchingWorkspaceId"
      [attr.aria-label]="'Switch workspace'"
      [attr.title]="canSwitchWorkspace ? 'Switch workspace' : workspaceName"
    >
      <span class="flex h-8 w-8 shrink-0 items-center justify-center">
        @if (showWorkspaceLogoImage) {
          <img
            class="h-8 w-8 object-contain rounded-full"
            [src]="workspaceLogoUrl"
            [alt]="workspaceName + ' logo'"
            (error)="onWorkspaceLogoError()"
          />
        } @else {
          <img src="assets/images/logo.png" alt="Workspace logo" class="h-8 w-8 rounded-full object-cover" />
        }
      </span>
      <span
        class="logo-text min-w-0 flex-1 truncate align-middle text-sm font-medium 2xl:text-base dark:text-white-light"
        >{{ workspaceName }}</span
      >
      @if (canSwitchWorkspace) {
        <svg
          class="h-4 w-4 shrink-0 text-gray-400 transition group-hover:text-primary dark:text-white-dark"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M7 15l5 5 5-5"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7 9l5-5 5 5"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      }
    </button>
    @if (canSwitchWorkspace) {
      <div
        *hlMenuItems
        @toggleAnimation
        class="!absolute left-0 -right-1 top-full z-[80] mt-2 w-[250px] overflow-hidden !rounded-xl border border-border !bg-muted !p-0 shadow-lg"
        [ngClass]="menuClass"
      >
        <div
          class="px-4 py-1 text-[11px] font-medium uppercase tracking-wide text-muted-foreground"
          aria-hidden="true"
        >
          Workspaces
        </div>
        <div class="px-2 py-2 bg-background rounded-xl">
        @for (workspace of workspaces; track workspace.id) {
          <li>
            <button
              type="button"
              *hlMenuItem
              class="flex w-full items-center gap-3 px-3 py-2.5 text-left transition rounded-xl"
              [ngClass]="{
                'bg-violet-50 text-foreground dark:bg-primary/20':
                  isCurrentWorkspace(workspace),
                'text-muted-foreground hover:bg-muted':
                  !isCurrentWorkspace(workspace)
              }"
              [disabled]="!!switchingWorkspaceId"
              (click)="switchWorkspace(workspace)"
            >
              <span class="flex h-8 w-8 shrink-0 items-center justify-center">
                @if (showOptionLogo(workspace)) {
                  <img
                    class="h-8 w-8 rounded-full object-cover"
                    [src]="workspace.logoUrl"
                    [alt]="workspace.displayName + ' logo'"
                    (error)="onOptionLogoError(workspace.id)"
                  />
                } @else {
                  <span
                    class="flex h-8 w-8 items-center justify-center rounded-full bg-slate-800 text-xs font-semibold tracking-tight text-sky-400"
                    aria-hidden="true"
                  >
                    {{ workspace.logoInitial }}
                  </span>
                }
              </span>
              <span class="min-w-0 flex-1 truncate text-xs font-medium 2xl:text-sm">{{
                workspace.displayName
              }}</span>
              @if (switchingWorkspaceId === workspace.id) {
                <span
                  class="inline-block h-4 w-4 shrink-0 animate-spin rounded-full border-2 border-violet-300 border-t-violet-600"
                ></span>
              } @else if (isCurrentWorkspace(workspace)) {
                <svg
                  class="h-4 w-4 shrink-0 text-foreground"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M20 6 9 17l-5-5"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              }
            </button>
          </li>
        }
        </div>
      </div>
    }
  </div>
</div>
